import React from 'react';

import { useSelector } from 'hooks';
import PageBaseProps from 'types/PageBase';
import FormKeys from 'modules/form/types/FormKeys';
import { getSelectedSelfServiceId } from 'modules/auth/selectors';
import { isBreakdownSelfService } from 'modules/selfServices/selectors';
import { useUpdateCustomerInfoMutation } from 'modules/selfServices/service';
import { CustomerInfo as CustomerInfoType } from 'modules/selfServices/types/CustomerInfo';

import Content from './Content';
import ConnectedForm from '../ui/ConnectedForm';

const CustomerInfo: React.FC<PageBaseProps> = ({ onNext, ...pageProps }) => {
  const isBreakdown = useSelector(isBreakdownSelfService);
  const selfServiceId = useSelector(getSelectedSelfServiceId);

  const [updateCustomer, { isLoading }] = useUpdateCustomerInfoMutation();

  const handleSubmit = React.useCallback(async (values: CustomerInfoType & { permanent: string }) => {
    const { permanent, ...formData } = values;
    try {
      await updateCustomer({ id: selfServiceId, params: { permanent: permanent === 'true' }, body: formData }).unwrap();
      onNext();
      // eslint-disable-next-line no-empty
    } catch {}
  }, [onNext, selfServiceId, updateCustomer]);

  return (
    <ConnectedForm
      onNext={onNext}
      component={Content}
      isLoading={isLoading}
      onSubmit={handleSubmit}
      formKey={FormKeys.CUSTOMER_INFO}
      isPhoneNumberOrEmailMandatory={!isBreakdown}
      subscription={{ pristine: true, errors: true }}
      {...pageProps}
    />
  );
};

export default CustomerInfo;
